import { ORDER_PAYMENT_VIEWS, Utilities, type Order } from 'core/domains';

export const initialState: Order = {
  data: {} as Order['data'],
  message: '',
  status: Utilities.STATUS.IDLE,
  updatedAt: 0,
  view: ORDER_PAYMENT_VIEWS.GENERIC,
};
